import { DataLayer } from '@piwikpro/react-piwik-pro';

import { LinkData, NavigationLinks, SubMenu } from '@mewa/types';

import t from '../../../libs/translate';
import {
  filterCleanroomIndustries,
  getServiceSegmentSlugForIndustry,
} from '../../templates/industry-page-helper';
import { NavigationData } from './types';

export const getProductMenuWithOverviewPages = (
  navigationData: NavigationData,
  locale: string,
  featureDev?: boolean,
): SubMenu[] => {
  const {
    navigationLinks: { navigation },
    navigationClothing: { nodes: clothingLinks },
    navigationNonClothing: { nodes: nonClothingLinks },
    navigationCleanRoom: { nodes: cleanRoomLinks },
    navigationIndustries: { nodes: industrieLinks },
  } = navigationData;

  const industryMenu = getIndustryLinks(industrieLinks, navigation, featureDev);

  return [
    {
      title: navigation.clothing.name,
      slug: navigation.clothing.slug,
      links: clothingLinks,
    },
    {
      title: navigation.nonClothing.name,
      slug: navigation.nonClothing.slug,
      links: nonClothingLinks,
    },
    ...(['de-DE', 'de-AT', 'de-CH'].includes(locale)
      ? [
          featureDev
            ? {
                title: navigation.cleanroom.name,
                slug: navigation.cleanroom.slug,
                links: cleanRoomLinks,
              }
            : {
                title: 'Reinraum',
                slug: 'reinraum',
                links: [],
              },
        ]
      : []),
    {
      title: navigation.industries.name,
      slug: navigation.industries.slug,
      links: industryMenu,
    },
  ];
};

const getIndustryLinks = (
  industries: NavigationData['navigationIndustries']['nodes'],
  navigation: NavigationLinks['navigation'],
  featureDev = false,
) =>
  industries.filter(filterCleanroomIndustries(featureDev)).map((industry) => {
    const ServiceSegmentSlug = getServiceSegmentSlugForIndustry(
      industry,
      navigation,
    );

    return {
      name: industry.name,
      slug: `${industry.slug}-${ServiceSegmentSlug}`,
    };
  });

export const getCompanyMenu = ({
  headerAndFooterTranslations: translations,
  navigationLinks,
  marketLanguageConfig,
}: NavigationData): SubMenu => {
  const companyLinks: LinkData[] = [
    // blog is included in this market
    ...(marketLanguageConfig.blog === 'true'
      ? [navigationLinks.blog.generalSlug]
      : []),
    navigationLinks.pressOverview,
    {
      name: t(translations, 'footer_career'),
      slug: marketLanguageConfig.careerPortal,
      isExternal: true,
      handleClick: () => {
        DataLayer.push({ event: 'external_career_header' });
      },
    },
    // add an external link to the blog
    ...(marketLanguageConfig.blog &&
    marketLanguageConfig.blog !== '' &&
    marketLanguageConfig.blog !== 'true'
      ? [
          {
            name: t(translations, 'footer_mewa_blog'),
            slug: marketLanguageConfig.blog,
            isExternal: true,
          },
        ]
      : []),
  ];

  return {
    slug: navigationLinks.navigation.company.slug,
    title: navigationLinks.navigation.company.name,
    links: companyLinks,
  };
};
